
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>«Hinterher ist man immer klüger»</h4>
    <p>
  Diese Zeitung bekommt den kompletten Untersuchungsbericht zugespielt. Verfasst wurde die Evaluation vom Sekretär des
  Ostschweizer Strafvollzugskonkordats und vom leitenden Staatsanwalt in Gossau SG. Die beiden Experten zeigen viel
  Verständnis für die Behörden: «Hinterher ist man immer klüger», diesen Satz habe man sich während der Beurteilung vor
  Augen gehalten, schreiben sie.
    </p>
    <p>
  Sieben Personen wurden befragt. Diese hätten den Fall als komplex beschrieben. Wegen der Persönlichkeit von William
  W., wegen der rechtlich anspruchsvollen Ausgangslage, wegen dem hohen Interesse von Öffentlichkeit, Politik und
  Medien. Selbstkritik übten die Befragten offenbar kaum. Man habe sehr viele Ressourcen eingesetzt. Ein Mitarbeiter
  sprach von einem «Paradefall», was die Zusammenarbeit der Abteilungen angehe. «Besser kann man es nicht machen.»
    </p>
    <p>
  Auch die St. Galler Experten selbst stellen den Solothurner Kollegen grundsätzlich ein gutes Zeugnis aus. Allerdings
  enthält ihr Untersuchungsbericht auch Kritikpunkte, welche in der publizierten Zusammenfassung fehlten. «In der
  Rückschau wäre es besser gewesen, wenn die ambulante Massnahme zeitnäher aufgehoben worden wäre.» Sie nehmen die
  Verantwortlichen aber in Schutz: «Es gab nach der Aktenlage objektiv keine erkennbaren konkreten Warnsignale für die
  neuen Übergriffe, auf welche Vollzugsbehörde, Bewährungshilfe und Therapeut sofort hätten reagieren müssen und
  können.» Unter Verschluss bleiben sollte auch ein weiterer Kritikpunkt der St. Galler Experten: Dass William W.
  systematisch gegen die Auflagen verstossen konnte, aber nichts passierte. «Es fragt sich, ob die Vollzugsbehörde nicht
  anders auf diese Vielzahl von Verstössen hätte reagieren können und müssen. Die zahlreichen Ermahnungen blieben
  nämlich ohne weitere Folgen», heisst es im Untersuchungsbericht. «Dies zeigt eine gewisse Hilflosigkeit der
  Vollzugsbehörde.»
  <Image source='Ein Mitarbeiter spricht laut Bericht von einem «Paradefall». (RD)' file={require('images/bericht_cover.png')} mdxType="Image" />
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;